import React from 'react'
import { bool, number, oneOf, func } from 'prop-types'

import { ICON_SIZE } from 'views/consts'

import StarIcon from 'views/components/atoms/StarIcon'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import { MAX_RATING } from './consts'

// eslint-disable-next-line react/prop-types
const Star = ({ name, index, iconSize, transparent, onClick, filled }) => {
  const className = filled ? 'm-StarRating__star-on qa-star-on' : 'qa-star-off'
  const starIconProps = {
    transparent,
    size: iconSize
  }

  if (filled) {
    starIconProps.filled = true
  }

  if (!onClick) {
    return (
      <li className={className}>
        <StarIcon {...starIconProps} />
      </li>
    )
  }

  return (
    <li className={className}>
      <ButtonAsLink name={name} onClick={() => onClick(index + 1)}>
        <StarIcon {...starIconProps} />
      </ButtonAsLink>
    </li>
  )
}

const Stars = ({ rating, iconSize, transparent, onClick }) => {
  const stars = []
  // handle float rating values
  const ratingRounded = Math.round(rating)
  let filled = true

  for (let i = 0; i < MAX_RATING; i += 1) {
    if (i === ratingRounded) {
      filled = false
    }
    const key = filled ? `star-rating-filled-${i}` : `star-rating-empty-${i}`

    stars.push(
      <Star
        key={key}
        {...{ name: key, index: i, iconSize, transparent, onClick, filled }}
      />
    )
  }
  return stars
}

Stars.propTypes = {
  rating: number.isRequired,
  iconSize: oneOf(ICON_SIZE),
  transparent: bool,
  onClick: func
}

Stars.defaultProps = {
  iconSize: 'small',
  transparent: false,
  onClick: null
}

export default Stars
